<template>
  <el-row class="tac">
    <el-col :span="24">
      <div v-for="(menu,index) in menuList" :key="index">
        <el-submenu  :index="menu.id.toString()">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <!-- <img :src="menu.isOpen?menu.activePicURL:menu.picURL" alt />&nbsp;&nbsp;&nbsp; -->
            <span  class="indexMenu">{{menu.name}}</span>
<!--            <i class="el-submenu__icon-arrow el-icon-caret-bottom"></i>-->
          </template>
          <!-- <NavMenu :menuList="menu.children"></NavMenu> -->
          <!-- <el-menu-item v-if="menu.children.length<=0" :index="menu.id"> -->

          <SubMenu :subMenuList="menu"></SubMenu>
        </el-submenu>

      </div>
    </el-col>
  </el-row>
</template>
<script>

import SubMenu from "./NavSubMenu";

export default {
  name: "NavMenu",
  components: {
    SubMenu,
  },
  props: ["menuList"],
  data(){
    return{
      imgsrc:"../../assets/images/leftmenu/addicon.png"
    }
  },
  mounted(){
  },
  methods: {
  }
};
</script>
<style scoped lang="scss">
.tac {
  width: 100%;
  background-color: #103047;
  height: 100%;
  text-align: left;

  /deep/.el-submenu__title {
    font-size: 18px;
    line-height: 76px;
    height: 76px;
  }

  /deep/.el-menu-item {
    display: flex;
    align-items: center;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }
  /deep/.el-icon-arrow-down:before{
    color: #069DBC;
  }
 /deep/.is-opened .indexMenu{
    color: white !important;
  }
}
</style>
